import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';
import { stringify } from 'qs';
//拣货组配置
export async function savePickgroupconfig(payload) {
  return request(`/iwms-wms/wms/pickgroupconfig`, {
    method: 'POST',
    body: payload,
  });
}

export async function removePickgroupconfig(payload) {
  return request(`/iwms-wms/wms/pickgroupconfig/${payload.uuid}`, {
    method: 'POST',
  });
}

export async function adjustPickgrouPriority(payload) {
  return request(`/iwms-wms/wms/pickgroupconfig/${payload.uuid}/adjustPriority?priority=${payload.priority}`, {
    method: 'POST',
  });
}

export async function modifyPickgroupconfig(payload) {
  return request(`/iwms-wms/wms/pickgroupconfig/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function pagePickgroupconfig(payload) {
  return request(`/iwms-wms/wms/pickgroupconfig/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryPickgroupconfig(payload) {
  return request(`/iwms-wms/wms/pickgroupconfig/getByDcUuid?dcUuid=${loginOrg().uuid}`, {
    method: 'GET',
  });
}

//动态区域配置
export async function saveDynamicareaconfig(payload) {
  return request(`/iwms-wms/wms/dynamicareaconfig`, {
    method: 'POST',
    body: payload,
  })
}

export async function removeDynamicareaconfig(payload) {
  return request(`/iwms-wms/wms/dynamicareaconfig/${payload.uuid}/remove`, {
    method: 'POST',
  })
}

export async function getDynamicareaconfig(payload) {
  return request(`/iwms-wms/wms/dynamicareaconfig/getByDcUuid?areaType=${payload.areaType}&dcUuid=${payload.dcUuid}`, {
    method: 'GET',
  })
}

export async function modifyDynamicareaconfig(payload) {
  return request(`/iwms-wms/wms/dynamicareaconfig/modify`, {
    method: 'POST',
    body: payload,
  })
}

export async function pageDynamicareaconfig(payload) {
  return request(`/iwms-wms/wms/dynamicareaconfig/page`, {
    method: 'POST',
    body: payload,
  })
}

//拣货组与区域对应关系接口
export async function removePickgrouparea(payload) {
  return request(`/iwms-wms/wms/pickgrouparea/${payload.uuid}`, {
    method: 'POST',
  })
}

export async function addPickgrouparea(payload) {
  return request(`/iwms-wms/wms/pickgrouparea/${payload.pickGroupConfigUuid}/add`, {
    method: 'POST',
    body: payload.list,
  })
}

export async function adjustPickgrouparea(payload) {
  return request(`/iwms-wms/wms/pickgrouparea/adjust?dcUuid=${loginOrg().uuid}&dynamicAreaConfigUuid=${payload.dynamicAreaConfigUuid}&pickGroupConfigUuid=${payload.pickGroupConfigUuid}&priority=${payload.priority}`, {
    method: 'POST',
  })
}

export async function pagePickgrouparea(payload) {
  return request(`/iwms-wms/wms/pickgrouparea/page`, {
    method: 'POST',
    body: payload,
  })
}


//删除前校验
export async function verifyDelete(payload) {
  return request(`/iwms-wms/wms/pickgroupconfig/verifyDelete`, {
    method: 'POST',
    body: payload,
  })
}
